module.exports = __webpack_public_path__ + "img/da8a235bb207c74eea21507f3a86a53b.svg";